<template>
    <div
        data-ecoffee-container
        class="transition-popup transform sm:m-8 flex flex-col"
        :class="[
            coffee.corner === 'topleft' ? 'top-0 left-0 items-start' : '',
            coffee.corner === 'topright' ? 'top-0 right-0 items-end' : '',
            coffee.corner === 'bottomleft' ? 'bottom-0 left-0 items-start' : '',
            coffee.corner === 'bottomright' ? 'bottom-0 right-0 items-end' : '',
            nonFixed ? 'absolute' : 'fixed',
        ]"
        :style="{
            'font-family': coffee.fontFamily,
        }"
    >
        <button
            id="logoSVG"
            :style="{
                'background-color': coffee.mainColor,
                color: coffee.buttonTextColor,
                height: `${coffee.coffeeSize}px`,
                width: `${coffee.coffeeSize}px`,
            }"
            :class="[
                coffee.corner === 'bottomleft' || coffee.corner === 'bottomright'
                    ? 'order-2 sm:mt-2'
                    : 'sm:mb-2',
                coffee.logo ? '' : 'pl-1',
            ]"
            class="m-4 sm:m-0 coffee_logo rounded-full flex items-center justify-center group cursor-pointer transition transform"
            data-ecoffee-show
        >
            <img
                data-ecoffee-logo-cup
                v-if="coffee.logo"
                :src="coffeeLogo"
                alt="logo"
                class="w-full h-full rounded-full"
            />
            <svg
                v-else
                data-ecoffee-logo-cup
                :width="Math.round(coffee.coffeeSize / 2)"
                :height="Math.round(coffee.coffeeSize / 2)"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.03931 17.9607H15.634"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M2.36609 12.6536V8.00983C2.36609 7.64345 2.6631 7.34644 3.02948 7.34644H12.9804V12.6536C12.9804 14.1191 11.7923 15.3071 10.3268 15.3071H5.01966C3.55413 15.3071 2.36609 14.1191 2.36609 12.6536Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.9804 7.34644H14.3072C15.7728 7.34644 16.9608 8.53448 16.9608 10C16.9608 11.4655 15.7728 12.6536 14.3072 12.6536H12.9804"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M5.68306 5.02464C7.12041 3.22794 4.2457 3.17267 5.68306 1.37598"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M9.66341 5.02464C11.1008 3.22794 8.22605 3.17267 9.66341 1.37598"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>

            <svg
                data-ecoffee-logo-x
                class="hidden"
                :width="Math.round(coffee.coffeeSize / 2)"
                :height="Math.round(coffee.coffeeSize / 2)"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14.1667 5.83334L5.83333 14.1667M5.83333 5.83334L14.1667 14.1667"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>

            <svg
                data-ecoffee-logo-heart
                class="hidden"
                :width="Math.round(coffee.coffeeSize / 2)"
                :height="Math.round(coffee.coffeeSize / 2)"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
            >
                <path
                    fill-rule="evenodd"
                    d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                    clip-rule="evenodd"
                />
            </svg>
        </button>
        <div
            data-ecoffee-adjust
            :style="{
                'background-color': coffee.backColor,
                color: coffee.textColor,
            }"
            :class="[
                coffee.corner == 'bottomleft' || coffee.corner == 'bottomright' ? 'order-1' : '',
            ]"
            class="sm:max-w-sm transition duration-500 rounded-t-lg sm:rounded-lg p-4 shadow-xl hidden opacity-0"
        >
            <div data-ecoffee-details>
                <span
                    :style="{ color: coffee.textColor }"
                    data-ecoffee-close
                    class="cursor-pointer opacity-50 hover:opacity-100 absolute top-2 right-2 block sm:hidden"
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M14.1667 5.83334L5.83333 14.1667M5.83333 5.83334L14.1667 14.1667"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </span>
                <cUtilsEdit v-if="coffee.title" @edit="goToContentField('coffeeTitle')">
                    <p
                        :style="{
                            'font-size': coffee.titleSize + 'px',
                        }"
                        class="mb-1 font-semibold leading-normal"
                    >
                        {{ coffee.title }}
                    </p>
                </cUtilsEdit>
                <cUtilsEdit v-if="coffee.desc" @edit="goToContentField('coffeeDesc')">
                    <p class="mb-5 opacity-80 leading-normal">{{ coffee.desc }}</p>
                </cUtilsEdit>
                <div
                    class="mb-4 grid grid-cols-3 gap-2"
                    :class="[coffee.showAmountInput ? 'sm:flex sm:items-center' : '']"
                >
                    <button
                        v-if="coffee.showDefaultAmount"
                        :style="{
                            'border-color': coffee.borderColor,
                        }"
                        :data-ecoffee-amount="coffee.amount1"
                        class="flex-shrink-0 leading-normal amount_label rounded-md px-4 py-2.5 text-center cursor-pointer opacity-80 hover:opacity-100 border border-gray-300"
                    >
                        <cUtilsEdit @edit="goToContentField('coffeeAmount1')">
                            <span>{{ coffee.amount1 }}</span>
                        </cUtilsEdit>
                    </button>
                    <button
                        v-if="coffee.showDefaultAmount"
                        :style="{
                            'border-color': coffee.mainColor,
                            'background-color': coffee.mainColor,
                            color: coffee.buttonTextColor,
                            opacity: 1,
                        }"
                        :data-ecoffee-amount="coffee.amount2"
                        class="flex-shrink-0 leading-normal amount_label rounded-md px-4 py-2.5 text-center cursor-pointer opacity-80 hover:opacity-100 border border-gray-300"
                    >
                        <cUtilsEdit @edit="goToContentField('coffeeAmount2')">
                            <span>{{ coffee.amount2 }}</span>
                        </cUtilsEdit>
                    </button>
                    <button
                        v-if="coffee.showDefaultAmount"
                        :style="{
                            'border-color': coffee.borderColor,
                        }"
                        :data-ecoffee-amount="coffee.amount3"
                        class="flex-srhink-0 leading-normal amount_label rounded-md px-4 py-2.5 text-center cursor-pointer opacity-80 hover:opacity-100 border border-gray-300"
                    >
                        <cUtilsEdit @edit="goToContentField('coffeeAmount3')">
                            <span>{{ coffee.amount3 }}</span>
                        </cUtilsEdit>
                    </button>
                    <div class="col-span-3 flex-grow w-full" v-if="coffee.showAmountInput">
                        <div class="relative">
                            <input
                                data-ecoffee-input
                                :style="{
                                    'background-color': coffee.backColor,
                                    color: coffee.textColor,
                                    'border-color': coffee.borderColor,
                                }"
                                :placeholder="coffee.amount2"
                                class="leading-normal w-full rounded-md px-4 py-2.5 pr-8 border border-gray-300"
                            />
                            <div class="absolute top-1/2 transform -translate-y-1/2 right-2">
                                <cUtilsEdit @edit="goToContentField('coffeeCurrency')">
                                    <span>{{ coffee.currency }}</span>
                                </cUtilsEdit>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="coffee.showNoteInput">
                    <textarea
                        data-ecoffee-note
                        :style="{
                            'background-color': coffee.backColor,
                            color: coffee.textColor,
                            'border-color': coffee.borderColor,
                        }"
                        :placeholder="$t('r_coffee.popup.add_note')"
                        class="w-full rounded-md px-4 py-2.5 border border-gray-300"
                        rows="3"
                    ></textarea>
                </div>
                <button
                    data-ecoffee-send
                    :disabled="!coffee.showDefaultAmount"
                    :style="{
                        'background-color': coffee.mainColor,
                        color: coffee.buttonTextColor,
                    }"
                    class="mt-6 group flex items-center justify-center enabled:cursor-pointer w-full rounded-md p-2 text-center opacity-90 enabled:hover:opacity-100 disabled:opacity-50 space-x-1"
                >
                    <span>{{ $t("r_coffee.popup.support_with") }}</span>
                    <p
                        :style="{
                            color: coffee.buttonTextColor,
                        }"
                        class="items-center"
                        :class="coffee.showDefaultAmount ? 'flex space-x-1' : 'hidden'"
                        data-ecoffee-selected-container
                    >
                        <span v-if="lang === 'en'">{{ coffee.currency }} </span>
                        <span data-ecoffee-selected-amount>{{ coffee.amount2 }}</span>
                        <span v-if="lang !== 'en'"> {{ coffee.currency }}</span>
                    </p>
                </button>
            </div>
            <div class="hidden" data-ecoffee-thanks>
                <p class="text-center">
                    {{ $t("r_coffee.popup.thank_you") }}
                </p>
            </div>
            <a
                id="madeWith"
                target="_blank"
                :style="{ color: coffee.textColor }"
                :href="appUrl"
                class="mt-2 text-sm p-2 block opacity-50 text-center"
            >
                {{ $t("r_coffee.popup.powered_with") }}
                <span class="underline">Easycoffee</span>
            </a>
        </div>
    </div>
</template>

<script>
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { useCoffeeGoTo } from "@/views/tools/coffee/utils/useCoffeeGoTo";
import { i18n } from "@/i18n";

export default {
    name: "CoffeeBody",
    props: {
        coffee: Object,
        nonFixed: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        cUtilsEdit,
    },
    setup() {
        const { goToContentField } = useCoffeeGoTo();
        return {
            goToContentField,
        };
    },
    data() {
        return {
            lang: i18n.global.locale.value,
            appUrl: "https://easy.tools/coffee",
        };
    },
    computed: {
        coffeeLogo() {
            return this.coffee.logo.includes("http")
                ? this.coffee.logo
                : `${process.env.VUE_APP_ORIGIN}${this.coffee.logo}`;
        },
    },
};
</script>
